module.exports = __webpack_public_path__ + "static/media/checkout.a17a2dfb.png";